/**
 *  BLOCK: Cloudbeds
 *  ---
 *  Add Cloudbeds Booking Engine iFrame to a Page
 */

const { __ } = wp.i18n
const { registerBlockType } = wp.blocks;

import EditBlock from "./EditBlock.js"

const cloudBedsSVG = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 380 380">
                    <style>{`.cb1{fill:#1b75bb}`}</style>
                    <path d="M380 380H0V0h380v380zM107.45 235.49c-.8-3.39-1.75-6.73-2.35-10.14-2.04-11.6-4.85-23.14-2.48-35.07 1.35-6.75 4.2-9.79 11.12-10.73 4.43-.6 8.92-.8 13.4-.97 19.27-.73 38.57-.99 57.82-2.17 26.49-1.62 52.86-1.53 79.08 3.02 7.58 1.31 10.41 3.9 10.18 11.99-.3 10.75-1.59 21.48-2.73 32.18-.4 3.7-1.64 7.31-2.28 10.08 13.82 5.75 26.94 11.33 40.2 16.57 1.5.59 4.22-.22 5.62-1.33 10.3-8.18 14.32-19.23 12.31-31.93-2.02-12.79-9.7-21.68-21.86-26.4-7.48-2.9-7.52-2.8-6.92-10.78 2.76-36.43-30.26-64.45-65.41-55.22-4.59 1.2-6.55.34-9-3.64-22.96-37.25-71.75-46.85-106.49-20.73-21.6 16.24-31.31 38.35-29.21 65.33.44 5.71-.58 8.27-6.79 10.24-16.21 5.12-25.58 17.15-27.85 33.89-2.04 15.11 3.44 27.8 15.22 37.55 1.34 1.11 3.83 2.25 5.15 1.74 11-4.19 21.84-8.78 33.27-13.48zm-65.53 56.46c8.67-3.61 16.64-7.36 24.9-10.3 34.21-12.19 69.91-16.08 105.85-16.69 25.06-.43 50.21 1.07 75.25 2.77 23.42 1.59 46.37 6.41 68.47 14.61 7.24 2.68 14.29 5.89 21.42 8.85.25-.34.5-.67.75-1.01-5.37-4.32-10.46-9.07-16.17-12.88-32.82-21.9-70-30.08-108.52-32.63-18-1.19-36.23-.31-54.28.79-26.05 1.6-51.23 7.68-75.28 17.93-15.73 6.72-30.33 15.23-42.39 28.56z" fill="#fff"/>
                    <path className="cb1" d="M107.45 235.49c-11.43 4.7-22.28 9.29-33.27 13.49-1.33.51-3.81-.63-5.15-1.74-11.78-9.75-17.27-22.44-15.22-37.55 2.26-16.74 11.64-28.77 27.85-33.89 6.22-1.96 7.24-4.52 6.79-10.24-2.1-26.98 7.6-49.09 29.21-65.33 34.74-26.11 83.53-16.52 106.49 20.73 2.45 3.98 4.41 4.84 9 3.64 35.15-9.23 68.17 18.79 65.41 55.22-.6 7.98-.57 7.88 6.92 10.78 12.16 4.71 19.84 13.61 21.86 26.4 2.01 12.7-2.02 23.75-12.31 31.93-1.4 1.11-4.12 1.92-5.62 1.33-13.26-5.23-26.39-10.81-40.2-16.57.65-2.77 1.89-6.38 2.28-10.08 1.15-10.71 2.43-21.44 2.73-32.18.23-8.09-2.6-10.67-10.18-11.99-26.23-4.55-52.59-4.63-79.08-3.02-19.24 1.18-38.54 1.43-57.82 2.17-4.47.17-8.97.38-13.4.97-6.92.93-9.78 3.97-11.12 10.73-2.38 11.93.44 23.47 2.48 35.07.6 3.4 1.56 6.74 2.35 10.13z"/>
                    <path className="cb1" d="M41.92 291.95c12.06-13.33 26.66-21.84 42.39-28.55 24.05-10.25 49.23-16.33 75.28-17.93 18.05-1.11 36.28-1.99 54.28-.79 38.52 2.55 75.71 10.73 108.52 32.63 5.71 3.81 10.8 8.56 16.17 12.88-.25.34-.5.67-.75 1.01-7.13-2.97-14.18-6.17-21.42-8.85-22.1-8.2-45.05-13.02-68.47-14.61-25.04-1.7-50.18-3.19-75.25-2.77-35.94.61-71.64 4.49-105.85 16.69-8.25 2.93-16.23 6.68-24.9 10.29z"/>
                    </svg>

registerBlockType('bed66-blocks/cloudbeds', {

    title: 'Cloudbeds',
  
    icon: cloudBedsSVG,
  
    category: 'bed66',
  
    attributes: {
      defaultURL: {
        type: 'string',
        default: 'https://cloudbeds-fcfc.kxcdn.com/wp-content/uploads/2019/02/CB_logo.svg'
      },
      tempURL: {
        type: 'string',
        default: 'https://cloudbeds-fcfc.kxcdn.com/wp-content/uploads/2019/02/CB_logo.svg'
      },
      url: {
        type: 'string',
        default: ''
      },
      widgetParam: {
        type: 'string',
        default: '?widget=1',
      },
      widthField: {
        type: 'string',
        default: '100%',
      },
      borderField: {
        type: 'string',
        default: '0'
      },
      scrollField: {
        type: 'string',
        default: 'no'
      },
      classField: {
        type: 'string',
        default: 'iframe-class'
      },
    },
  
    edit: EditBlock,
  
    save( { attributes } ) {
      const { url, widgetParam, widthField, borderField, scrollField, classField } = attributes;
  
      return (
        <div>
        <iframe src={url + widgetParam} width={widthField} frameborder={borderField} scrolling={scrollField} class={classField} id="bed66_iFrame"></iframe>
        </div>
        );
    },

  });